import React from "react";
import Breadcrumbs from "../../../Breadcrumbs/Breadcrumbs.js";
import Questions from "../Questions/Questions.js";
import useSEO from "../../../hooks/useSEO.js";
import seoConfig from "../../../hooks/seoConfig.js";

export default function CertificationCycle() {
  useSEO(seoConfig.certificationCycle);

  return (
    <section className="contacts additional">
      <Breadcrumbs />

      <h1 className="contacts__title history__title licenses__title">
        Сертификационный цикл
      </h1>

      <h3 className="about-nii__title antiCorruption__title additional__title">
        ГБУ СО «УрНИИДВиИ» проводит цикл повышения квалификации по
        дерматовенерологии с последующей сдачей сертификационного экзамена и
        продлением сертификата специалиста – дерматовенеролога.
      </h3>

      <p className="dissertation__text">
        Обучение предназначено для врачей – дерматовенерологов и включает
        посещение лекций, семинаров, а также практических занятий в следующих
        подразделениях Института:
      </p>

      <ol>
        <li>
          <p className="dissertation__text">Отдел клинической дерматологии</p>
        </li>
        <li>
          <p className="dissertation__text">Отделение микологии</p>
        </li>
        <li>
          <p className="dissertation__text">Отделение венерологии</p>
        </li>
        <li>
          <p className="dissertation__text">Отделение детской дерматологии</p>
        </li>
        <li>
          <p className="dissertation__text">Поликлиническое отделение</p>
        </li>
      </ol>

      <p className="dissertation__text">
        Продолжительность обучения - 144 часа. По окончании цикла проводится
        сертификационный тестовый экзамен и собеседование.
      </p>
      <p className="dissertation__text">
        Обучение осуществляется на договорной основе.
      </p>

      <p className="dissertation__text">
        Для оформления договоров на обучение необходимы следующие документы,
        заверенные нотариусом:
      </p>
      <ul>
        <li>
          <p className="dissertation__text">Паспорт;</p>
        </li>
        <li>
          <p className="dissertation__text">
            Диплом об окончании медицинского института по специальности
            «Лечебное дело» или «Педиатрия»;
          </p>
        </li>
        <li>
          <p className="dissertation__text">
            Удостоверение об окончании клинической ординатуры или диплом о
            профессиональной переподготовке по специальности
            «дерматовенерология»;
          </p>
        </li>
        <li>
          <p className="dissertation__text">
            Копия трудовой книжки (работа врачом – дерматовенерологом),
            заверенная печатью, подписью начальника отдела кадров с указанием
            «работает по настоящее время»;
          </p>
        </li>
        <li>
          <p className="dissertation__text">Сертификат специалиста;</p>
        </li>
        <li>
          <p className="dissertation__text">
            Характеристика с места работы, заверенная подписью руководителя и
            печатью учреждения;
          </p>
        </li>
        <li>
          <p className="dissertation__text">
            Перечень практических навыков, которым владеет специалист,
            заверенный руководителем.
          </p>
        </li>
      </ul>

      <p className="dissertation__text">
        Общежитие на время обучения не предоставляется.
      </p>
      <p className="dissertation__text">
        После сдачи сертификационного экзамена продлевается сертификат
        специалиста и выдается Свидетельство о повышении квалификации.
      </p>

      <Questions />
    </section>
  );
}
